/**
 * Represents rich text in a cell.
 */
export class RichText {
  public readonly runs: RichTextRun[] = [];

  constructor(public readonly element: Element) {
    for (const run of this.element.getElementsByTagName('r')) {
      this.runs.push(new RichTextRun(run));
    }
  }

  toHtml(): HTMLElement {
    const div = document.createElement('div');
    for (const run of this.runs) {
      div.appendChild(run.toHtml());
    }
    return div;
  }
}

/**
 * Represents a run of rich text.
 */
export class RichTextRun {
  public readonly element: Element;
  public readonly rPrElement: Element;
  public readonly textElement: Element;

  public get text(): string {
    return this.textElement.textContent ?? '';
  }
  public set text(value: string) {
    this.textElement.textContent = value;
    // Set xml:space accordingly
    if (value.trim() !== value) {
      this.textElement.setAttribute('xml:space', 'preserve');
    } else {
      this.textElement.removeAttribute('xml:space');
    }
  }

  public get bold(): boolean {
    return this.rPrElement.getElementsByTagName('b').length > 0;
  }

  public get italic(): boolean {
    return this.rPrElement.getElementsByTagName('i').length > 0;
  }

  public get underline(): boolean {
    return this.rPrElement.getElementsByTagName('u').length > 0;
  }

  constructor(element: Element) {
    this.element = element;
    this.rPrElement = element.getElementsByTagName('rPr')[0]!;
    this.textElement = element.getElementsByTagName('t')[0]!;
  }

  toHtml(): HTMLElement {
    const span = document.createElement('span');
    span.innerHTML = this.text;
    if (this.bold) {
      span.style.fontWeight = 'bold';
    }
    if (this.italic) {
      span.style.fontStyle = 'italic';
    }
    if (this.underline) {
      span.style.textDecoration = 'underline';
    }
    return span;
  }
}
